import React from "react";
import Nav from "../Nav/Nav";

const Blog = () => {
  return (
    <div>
      <Nav></Nav>
      <h2>Bogger is sleeping</h2>
    </div>
  );
};

export default Blog;
